import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionHeader from '../shared/SectionHeader';
import '../../styles/landing/ProblemSection.css';

const ProblemSection: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section className="landing-section landing-section--cream" aria-labelledby="problem-heading">
            <div className="landing-container">
                <SectionHeader title={t('problem.title')} id="problem-heading" />
                <div className="problem-section__grid">
                    <article className="problem-section__card landing-card">
                        <div className="problem-section__icon" aria-hidden="true" />
                        <h3 className="problem-section__card-title">{t('problem.guests.title')}</h3>
                        <p className="problem-section__card-body">{t('problem.guests.body')}</p>
                    </article>
                    <article className="problem-section__card landing-card">
                        <div className="problem-section__icon problem-section__icon--couples" aria-hidden="true" />
                        <h3 className="problem-section__card-title">{t('problem.couples.title')}</h3>
                        <p className="problem-section__card-body">{t('problem.couples.body')}</p>
                    </article>
                </div>
            </div>
        </section>
    );
};

export default ProblemSection;
